/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Labels_Sociaal_Emotionele_ThemasInputs */

const nl_common_labels_sociaal_emotionele_themas = /** @type {(inputs: Common_Labels_Sociaal_Emotionele_ThemasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sociaal-emotionele thema's`)
};

/**

* @param {Common_Labels_Sociaal_Emotionele_ThemasInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_labels_sociaal_emotionele_themas = /** @type {((inputs?: Common_Labels_Sociaal_Emotionele_ThemasInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Labels_Sociaal_Emotionele_ThemasInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_labels_sociaal_emotionele_themas(inputs)
});
export { common_labels_sociaal_emotionele_themas as "common.labels.sociaal_emotionele_themas" }